const $$splitNotFoundComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/route.tsx?tsr-split=notFoundComponent');
const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { ldContextFactory } from '@/app';
import { FullSizeSpinner } from '@/components/ui/FullSizeSpinner';
import { setTokenProvider } from '@/lib/api/tempoApi';
import type { FlagKeys } from '@/lib/providers/featureFlagProvider';
import { getJwtUserContext } from '@/lib/utils/common/getJwtUserContext';
export const Route = createFileRoute('/(app)')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  pendingComponent: FullSizeSpinner,
  notFoundComponent: lazyRouteComponent($$splitNotFoundComponentImporter, 'notFoundComponent'),
  beforeLoad: async ({
    context
  }) => {
    const {
      auth,
      flagOverrides
    } = context;
    if (!auth) {
      throw redirect({
        to: '/'
      });
    }
    if (!auth.isLoading && !auth.isAuthenticated) {
      if (auth.error) {
        if (auth.error.message.includes('invitation')) {
          throw redirect({
            to: '/organizations/invites/error',
            search: {
              message: auth.error.message
            }
          });
        }
      }
      throw auth.loginWithRedirect({
        appState: {
          returnTo: window.location.href
        }
      });
    }
    let flags = {} as FlagKeys;
    try {
      const {
        getAccessTokenSilently
      } = auth ?? {};
      const accessToken = getAccessTokenSilently ? await getAccessTokenSilently() : undefined;
      if (getAccessTokenSilently) {
        setTokenProvider(getAccessTokenSilently, accessToken);
      }
      const authContext = getJwtUserContext(accessToken);
      const {
        userId,
        organizationId,
        organizationName
      } = authContext;
      if (context.ldClient) {
        const ldCtx = ldContextFactory.multiContext({
          organizationInput: {
            organizationId,
            organizationName
          },
          userInput: {
            userId
          }
        });
        await context.ldClient.identify(ldCtx);
        const allFlags = context.ldClient.allFlags();
        flags = {
          ...allFlags,
          ...flagOverrides
        } as FlagKeys;
      }
      return {
        flags,
        accessToken,
        ...authContext
      };
    } catch {
      return {
        flags,
        accessToken: undefined,
        subscription: undefined,
        userId: undefined,
        organizationId: undefined,
        auth0OrganizationId: undefined,
        organizationName: undefined,
        connectionName: undefined,
        authError: true
      };
    }
  }
});